module.exports = __webpack_public_path__ + "img/grian-231073db-094a-4e5d-d664-08d957755ecc.png";